import { Box, Text } from '@chakra-ui/react'
import Header from '../Header'
import PageTransition from '../components/PageTransition'
import PortfolioCalculator from '../PortfolioCalculator'

const PortfolioManagement = (): JSX.Element => (
  <>
    <Header title="Portfolio Management" subtitle="Manage your investment portfolio" />
    <PageTransition>
      <Box p={4}>
        <Text fontSize="md">
          The problem with society's bitcoinization process is that there isn't a unified glidepath for how newcomers can slot Bitcoin into their existing portfolios.
        </Text>
        <Text fontSize="md" mt={4}>
          The typical advice to new bitcoiners from veterans is to go all in on Bitcoin and to not hold any other assets. This is not practical for most people, especially those who are already invested in traditional assets like stocks, bonds, real estate, etc. A more realistic approach is to gradually increase one's exposure to Bitcoin, but what is the best way to do this, at what pace, at what phase of life, and starting with what composition of assets going into the exercise?
        </Text>
        <Text fontSize="md" mt={4}>
          Moreover, there is something to be said for a newcomer's comfort level with the concept of a digital asset and it's perfectly acceptable for someone to be interested and to potentially willing to make some allocation without committing too heavily to a new asset class.
        </Text>
        <Text fontSize="md" mt={4}>
          The purpose of this forthcoming calculator is to provide a tool for newcomers to explore how different values, priorities, and phases of life might affect the degree to which they should allocate to Bitcoin.
        </Text>

        <Box mt={8}>
          <PortfolioCalculator />
        </Box>
      </Box>
    </PageTransition>
  </>
)

export default PortfolioManagement
